import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

export class cuestionarios{
  id?:String;
  institution_id?: String;
  name?: String;
  shortName?: String;
  description?: String;
  startDate?: String;
  dueDate?: String;
  weighting?: Number;
  allowMultipleAnswers?: Boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CuestionariosService {
  private apiURL = environment.api_cuestionarios_rest;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  
  constructor(
    private cookieService: CookieService,
    private http: HttpClient
  ) {}

  public postCuestionario(cuestionario){
    const cues: cuestionarios = {
      name: cuestionario.nombre,
      shortName: cuestionario.nombreCorto,
      description: cuestionario.usuario,
      weighting: 0,
      allowMultipleAnswers: cuestionario.allowMultipleAnswers
    }
    const body = JSON.stringify(cues);
    const apiURL = this.apiURL+"questionnaires";
    return this.http.post(`${apiURL}`,body, {headers: this.headers});
  }
  public deleteCuestionario(id: string) {
    const apiURL = this.apiURL+"questionnaires/"+id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
    //return this.http.delete<string>(apiURL + id, {headers: this.headers});
  }
  public updateCuestionario(cuestionario){
    const cues: cuestionarios = {
      name: cuestionario.nombre,
      shortName: cuestionario.nombreCorto,
      description: cuestionario.usuario,
      allowMultipleAnswers: cuestionario.allowMultipleResponses
    }
    const body = JSON.stringify(cues);
    const apiURL = this.apiURL+"questionnaires/"+cuestionario.id;
    return this.http.patch(`${apiURL}`,body, {headers: this.headers});
  }

  public statusCuestionario(id: string, status: string) {
    const apiURL = this.apiURL+"questionnaires/"+id+'/status/'+status;
    return this.http.post(`${apiURL}`, undefined, {headers: this.headers});
  }
  
}
